import UrlManager from 'manager/urlManager'
import Utils from 'common/utils'
import Network from 'common/network'
import DeviceTokenManger from 'manager/deviceTokenManager'
import LocationStore from 'stores/locationStore'
class UserSelectedLocationsDataSource {

    static sendSelectedLocations() {
        return new Promise((resolve, reject) => {

            let { deviceID = '', fcmToken = '' } = DeviceTokenManger.fetchToken() || {}
            if (Utils.isEmptyStr(deviceID) || Utils.isEmptyStr(fcmToken)) {
                reject(new Error(`Device Id and FCM Token cannot be empty! DeviceId: ${deviceID}, FCMToken ${fcmToken} `))
                return;
            }
            const geoLoc = LocationStore.getGeoLocationFromStore()
            let locations = LocationStore.getLocationsFromStore() || []

            //Check if GeoLocation is already present in store else add it
            if (geoLoc && !locations.some(loc => loc && loc.latitude === geoLoc.latitude && loc.longitude === geoLoc.longitude)) {
                locations = [...locations, geoLoc]
            }
            if (!locations || !Array.isArray(locations) || locations.length === 0) {
                console.error("locations cannot be empty!")
                //reject(new Error("locations cannot be empty!"))
                return
            }

            let processLocations = locations.map(loc => {
                const { latitude, longitude, area, zipCode } = loc
                return new LocationParams(latitude, longitude, area ? area.city : '', zipCode)
            })

            let url = `${UrlManager.getSelectedLocationsEndpoint()}`
            let headers = {
                "Content-Type": "application/json"
            }
            let body = {
                locations: processLocations,
                fcmToken,
                deviceID
            }

            Network.post(
                url,
                headers,
                body,
                true
            )
                .then((response) => {
                    if (false === response.ok) {
                        throw new Error(`invalid response status - ${response}`)
                    }
                    return response.json()
                })
                .then((responseJson) => {

                    console.log("Response from locations API: ", JSON.stringify(responseJson, null, 4))
                    resolve(responseJson)
                })
                .catch((e) => {
                    console.log(e);
                })
        })
    }

}

class LocationParams {
    constructor(latitude, longitude, area, zipCode) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.area = area;
        this.zipcode = zipCode
    }
}

export default UserSelectedLocationsDataSource



// WEBPACK FOOTER //
// ./src/dataSource/userSelectedLocationsDataSource.js